import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { withSnackbar } from "notistack";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import Events from "../../../../../../utilities/EventEmitter";
import DialogTitleHeader from "../common/DialogTitleHeader";
import ProcessDelivery from "./ProcessDelivery";
import DeliveryReceipt from "./DeliveryReceipt";
import constants from "./constants";
import { postData, getDataWithQueryString } from "../../../../../../api/componentAPIs";
import { RMAXLogger } from "../../../../../../services/LoggerService/RMAXLogger";
import appConstants from "../../../../../../appConstants";
import { sortBy } from 'lodash';
import { getStopTimeWithOffset, getStopHeaderText } from "./util";
import { sanitizeObject } from "../../../../../../utilities/dataUtils";

const dialogStyles = (theme) => ({
  root: {
    margin: 0,
    marginBottom: 0,
    padding: 16,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 16,
    color: theme.iconColor,
  },
  actionButton: { minWidth: "136px" },
});

const DialogTitle = withStyles(dialogStyles)((props) => {
  const { children, classes, onClose, handleClose, ...other } = props;
  return (
    <div>
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        {children}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
    </div>
  );
});

class ProcessDeliveryDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessDeliveryInProgress: false,
      processDeliveryDataPerStep: {},
      activeStep: constants.PROCESS_DELIVERY_STEPS.PROCESS_DELIVERY,
      freightBillData: [],
      stopData: this.props.stopData || {}
    };
    this.timer = null;
  }

  componentDidMount() {
    if (this.props.stopData.isStopCompleted) {
      this.getDeliveryStopData();
    }
    Events.on("DeliveryCompleted", this.checkDeliveryCompletedStatus);
    this.getFreightBillsForStops();
  }

  componentWillUnmount() {
    Events.off("DeliveryCompleted", this.checkDeliveryCompletedStatus);
  }

  getFreightBillsForStops = () => {
    getDataWithQueryString(
      "GetFreightBillDetails",
      `terminalCode=${this.props.userData.userProfile.terminal.code}&routeId=${this.props.routeData.routeId}&stopId=${this.props.stopData.stopId}`
    ).then((response) => {
      if (response && response.status === 200) {
        this.setState({
          freightBillData: sortBy(response.data, "sequence")
        });
      }
    });
  };

  getDeliveryStopData = () => {
    const { userData, routeData, stopData } = this.props;
    getDataWithQueryString(
      'GetDeliveryStopData',
      `terminalCode=${userData.userProfile.terminal.code}&routeId=${routeData.routeId}&stopId=${stopData.stopId}`
    )
      .then((response) => {
        if (response?.status === 200) {
          this.setState({ stopData: { ...this.props.stopData, ...response.data, stopSequence: this.props.stopData.stopSequence } });
        } else {
          this.handleDeliveryStopDataError();
        }
      })
      .catch(() => {
        this.handleDeliveryStopDataError();
      });
  };

  handleDeliveryStopDataError = () => {
    this.props.enqueueSnackbar('Stop data not found!', { variant: 'error' });
    this.props.handleClose();
  };

  checkDeliveryCompletedStatus = (data) => {
    const { success } = data;
    if (success) {
      this.props.handleClose();
      this.props.enqueueSnackbar(`Delivery completed `, {
        variant: "success"
      });
    } else {
      this.props.enqueueSnackbar(`Failed to complete delivery`, {
        variant: "error"
      });
      this.setState({
        isProcessDeliveryInProgress: false
      });
    }
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
    clearTimeout(this.timer);
  };

  getShipmentsList = () => {
    const { proData } = this.state;
    let shipmentArr = [];
    proData.forEach((stop) => {
      shipmentArr = shipmentArr.concat(
        stop.deliveryInfo?.filter(
          (shipment) =>
            shipment.editProData.deliveryCode !== appConstants.DELIVERY_CODE.RTN
        )
      );
    });
    return shipmentArr;
  };

  handlePrevious = () => {
    this.setState({
      activeStep: constants.PROCESS_DELIVERY_STEPS.PROCESS_DELIVERY
    });
  };

  submitProData = ({
    processDeliveryData,
    proData,
    stopTimeDetails,
    isDriverAllowedInside,
    isReturn,
    allProsMarkedTA
  }) => {
    this.setState(
      (prevState) => ({
        processDeliveryDataPerStep: {
          ...prevState.processDeliveryDataPerStep,
          [this.state.activeStep]: processDeliveryData
        },
        proData,
        stopTimeDetails,
        isDriverAllowedInside,
        allProsMarkedTA,
        activeStep: isReturn
          ? constants.PROCESS_DELIVERY_STEPS.PROCESS_DELIVERY
          : constants.PROCESS_DELIVERY_STEPS.DELIVERY_RECEIPT
      }),
      () => isReturn && this.processDelivery()
    );
  };

  getStopsData = () => {
    const { proData } = this.state;
    return proData.map(({ stop, deliveryInfo }) => ({
      stopId: stop.stopId,
      deliveryInfo: deliveryInfo.map((data) => data.editProData)
    }));
  };

  populateRequestParams = (receiverDetails = {}) => {
    const {
      stopTimeDetails: { stopTime },
      isDriverAllowedInside
    } = this.state;
    const {
      routeData,
      stopData,
      userData: {
        userProfile: { terminal }
      }
    } = this.props;
    const { arrivalTime, departureTime } = getStopTimeWithOffset(
      stopTime,
      terminal.offset
    );
    return {
      driverId: routeData.driverId,
      stopId: stopData.stopId,
      routeId: routeData.routeId,
      terminalCode: terminal.code,
      eventDateTime: new Date(),
      stops: this.getStopsData(),
      isDriverAllowedInside,
      ...receiverDetails,
      arrivalTime,
      departureTime,
      isReprocessEvent:stopData.isStopCompleted
    };
  };

  onProcessDeliveryProgressTimeOut = () => {
    this.timer = setTimeout(() => {
      this.setState({ isProcessDeliveryInProgress: false });
    }, appConstants.ONE_MINUTE_TIME_OUT);
  };

  processDelivery = (receiverDetails) => {
    const requestParams = sanitizeObject(this.populateRequestParams(receiverDetails));
    RMAXLogger.info("Complete_Delivery", {
      action: "CompleteDeliveryStop Clicked",
      stopId: requestParams?.stopId,
      routeId: requestParams?.routeId,
      driverId: requestParams?.driverId,
      stopCount: requestParams?.stops?.length ?? 0
    });
    this.setState(
      {
        isProcessDeliveryInProgress: true
      },
      this.onProcessDeliveryProgressTimeOut
    );
    this.props.glEventHub.emit("DispatchEvents", "ShowLoaderDialog", [
      "Processing delivery"
    ]);
    postData("CompleteDeliveryStop", requestParams).then((response) => {
      if (response && Math.trunc(response.status / 100) === 2) {
        this.setState({
          isProcessDeliveryInProgress: false
        });
        return;
      }
      this.handleError(response.status);
    }, () => {
      this.handleError();
    });
  };

  handleError = (statusCode) => {
    this.setState({
      isProcessDeliveryInProgress: false
    });
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(`Failed to complete delivery`, {
      variant: "error"
    });
  }

  getDialogHeader = () => {
    return this.state.activeStep ===
      constants.PROCESS_DELIVERY_STEPS.PROCESS_DELIVERY
      ? getStopHeaderText(this.props.stopData.isStopCompleted)
      : "Delivery Receipt";
  };

  getReceiverDetails = () => {
    const { stopData } = this.state;
    if (this.props.stopData.isStopCompleted) {
      return stopData.hasOwnProperty('shipments') && stopData.shipments.length > 0
        ? stopData.shipments[stopData.shipments.length - 1].receiverDetails || {}
        : null;
    } else {
      return {};
    }
  };

  render() {
    const { classes, open, handleClose, routeData, isDriverArrived } = this.props;
    const {
      isProcessDeliveryInProgress,
      processDeliveryDataPerStep,
      activeStep,
      freightBillData,
      stopData
    } = this.state;
    const { theme } = this.props.userData.userProfile || {};
    const receiverDetails = this.getReceiverDetails();
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${theme}`}
        >
          <DialogTitle
            handleClose={handleClose}
            id="customized-dialog-title"
            className={classes.divider}
          >
            <DialogTitleHeader label={this.getDialogHeader()} />
          </DialogTitle>
          <DialogContent
            classes={{ root: classes.dialogContent }}
            className="customScroll"
          >
            {this.state.activeStep ===
              constants.PROCESS_DELIVERY_STEPS.PROCESS_DELIVERY && (
              <ProcessDelivery
                isProcessDeliveryInProgress={isProcessDeliveryInProgress}
                handleClose={handleClose}
                isDriverArrived={isDriverArrived}
                processDeliveryData={processDeliveryDataPerStep?.[activeStep]}
                stopData={stopData}
                routeData={routeData}
                submitProData={this.submitProData}
                freightBillData={freightBillData}
              />
            )}
            {this.state.activeStep ===
              constants.PROCESS_DELIVERY_STEPS.DELIVERY_RECEIPT && (
              <DeliveryReceipt
                isProcessDeliveryInProgress={isProcessDeliveryInProgress}
                handleClose={handleClose}
                handlePrevious={this.handlePrevious}
                stopData={stopData}
                routeData={routeData}
                shipmentList={this.getShipmentsList()}
                processDelivery={this.processDelivery}
                allProsMarkedTA={this.state.allProsMarkedTA}
                freightBillData={freightBillData}
                receiverDetails={receiverDetails}
              />
            )}
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar
)(ProcessDeliveryDialog);
